import React, { useState, useEffect } from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface CorsIssue {
  message: string;
  timestamp: number;
}

const CorsNotification: React.FC = () => {
  const { theme } = useTheme();
  const [show, setShow] = useState<boolean>(false);
  const [corsIssues, setCorsIssues] = useState<CorsIssue[]>([]);

  useEffect(() => {
    // Detectar errores de CORS en la consola
    const originalError = console.error;
    console.error = (...args: any[]) => {
      const message = args.join(' ');
      if (message.includes('CORS') || message.includes('Access-Control-Allow-Origin') || message.includes('CORS_ERROR')) {
        setCorsIssues(prev => {
          const newIssues = [...prev];
          if (!newIssues.some(issue => issue.message === message)) {
            newIssues.push({ message, timestamp: Date.now() });
          }
          return newIssues;
        });
        setShow(true);
      }
      originalError.apply(console, args);
    };

    return () => {
      console.error = originalError;
    };
  }, []);

  if (!show || corsIssues.length === 0) return null;

  const isDark = theme === 'dark';

  return (
    <div className={`fixed top-4 right-4 max-w-md p-4 rounded-lg shadow-lg z-50 ${
      isDark 
        ? 'bg-yellow-900 border-yellow-700 text-yellow-100' 
        : 'bg-yellow-50 border-yellow-200 text-yellow-800'
    } border`}>
      <div className="flex justify-between items-start mb-2">
        <strong className="flex items-center gap-2">
          <i className="pi pi-exclamation-triangle text-yellow-500"></i>
          Problema de Conexión
        </strong>
        <button 
          onClick={() => setShow(false)}
          className="text-yellow-600 hover:text-yellow-800 dark:text-yellow-400 dark:hover:text-yellow-200 text-xl leading-none p-0 ml-2"
        >
          ×
        </button>
      </div>
      <p className="mb-3 text-sm">
        Hay problemas de CORS con el backend. Se están usando datos de prueba para desarrollo.
      </p>
      <div className="text-xs text-gray-600 dark:text-gray-300">
        <p className="mb-1 font-medium">Para solucionarlo:</p>
        <ul className="list-disc list-inside space-y-1">
          <li>Verifica que el backend esté funcionando</li>
          <li>Configura CORS en el servidor</li>
          <li>Usa un proxy en desarrollo</li>
        </ul>
      </div>
    </div>
  );
};

export default CorsNotification;

